const Rate = [
    {id: "0", value: "現金殖利率"},    
    {id: "1", value: "股票殖利率"},
    {id: "2", value: "會計殖利率"},
    {id: "3", value: "還原殖利率"},        
  ];  
  
  export default Rate  